module.exports = __webpack_public_path__ + "img/flecha-baixo-circulada.eff69a62.svg";